import { AccountSetting, useAccountSetting } from './account-settings';
import { AccountFeatureFlag, useFeatureFlag } from './feature-flags';

/** The flag gates visibility; the setting is the account's own opt-in to recording. Need both. */
export function useConsentRecordsEnabled(): boolean {
  const hasFlag = useFeatureFlag(AccountFeatureFlag.ConsentRecords);
  const hasSetting = useAccountSetting(AccountSetting.ConsentRecords);
  return hasFlag && hasSetting;
}
